import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers";
import thunkMiddleware from "redux-thunk";
import { PERSISTENCE_KEY } from "../constants";
import { debounce } from "lodash-es";

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        trace: true
      })
    : compose;

const enhancer = composeEnhancers(
  applyMiddleware(
    thunkMiddleware // lets us dispatch() functions
  )
  // other store enhancers if any
);

// restore the state from persistence
const preloadedState = sessionStorage.getItem(PERSISTENCE_KEY)
  ? JSON.parse(sessionStorage.getItem(PERSISTENCE_KEY))
  : {};

const store = createStore(rootReducer, preloadedState, enhancer);

// state persistence
store.subscribe(
  debounce(
    () => {
      sessionStorage.setItem(
        PERSISTENCE_KEY,
        JSON.stringify({
          ...store.getState(),
          loadingCounter: 0
        })
      );
    },
    500,
    { trailing: true }
  )
);

export default store;
